import { render, staticRenderFns } from "./WidgetHeading.vue?vue&type=template&id=14846b76&scoped=true"
import script from "./WidgetHeading.vue?vue&type=script&lang=js"
export * from "./WidgetHeading.vue?vue&type=script&lang=js"
import style0 from "./WidgetHeading.vue?vue&type=style&index=0&id=14846b76&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14846b76",
  null
  
)

export default component.exports